import type { schemaType as strapiHolidaysSchemaType } from '~~/shared/api/strapi/vacaciones-landings/detail/schema'
import type { schemaType as ruralityReviewsSchemaType } from '~~/shared/api/rurality/v3/cottage-reviews/province/summary/schema'
import type { productParams } from '~~/modules/head/composables/useHeadSchemaComposable'

export const useToProduct = () => {
  const fromStrapiHolidaysAndRuralityReviews = (params: {
    strapiHolidays: strapiHolidaysSchemaType
    ruralityReviews: ruralityReviewsSchemaType
    sku: string
  }): productParams => {
    const item: productParams = {
      name: t('landings.holidays.seo.schema', {
        name: params.strapiHolidays.attributes.name,
      }),
      description: t('landings.holidays.seo.description', {
        name: params.strapiHolidays.attributes.name,
      }),
      image: params.strapiHolidays.attributes.img?.data?.attributes
        .url as string,

      sku: params.sku,

      aggregateRating: {
        ratingValue: params.ruralityReviews.averageReviewScore,
        bestRating: params.ruralityReviews.bestScore,
        ratingCount: params.ruralityReviews.countScore,
      },
    }

    return item
  }

  return { fromStrapiHolidaysAndRuralityReviews }
}
